import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { valouseTranslations } from '../../translations/valouseTranslations';
import { sanitizeHTML } from '../../utils/sanitize';

const InsideCoconSection = () => {
  const { language } = useLanguage();
  const t = (obj) => obj[language] || obj['fr'];
  const tr = valouseTranslations;

  return (
    <section className="py-12 sm:py-16 px-6 bg-[#F3E5CF]">
      <div className="max-w-3xl mx-auto space-y-10">
        
        {/* Bloc - Ce qui se vit à l'intérieur */}
        <div className="px-6 py-10 rounded-2xl bg-[#F3E5CF] border border-[#3F2A24]/30 text-center space-y-6 text-[#3F2A24]">
          
          {/* Premium micro-heading structure */}
          <div className="space-y-3">
            <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#C5A059]">
              {t(tr.insideCocon.contextLine)}
            </p>
            <h2 
              className="font-serif text-xl sm:text-2xl md:text-3xl text-[#C5A059]"
              style={{ textWrap: 'balance' }}
            >
              {t(tr.insideCocon.title)}
            </h2>
            <p 
              className="font-serif text-sm text-[#3F2A24]/70 italic"
              style={{ textWrap: 'balance' }}
            >
              {t(tr.insideCocon.poeticLine)}
            </p>
          </div>
          
          <div className="w-12 h-[1px] bg-[#C5A059]/60 mx-auto" />
          
          <div className="space-y-4 text-base sm:text-lg leading-[1.9] text-[#3F2A24]">
            <p style={{ textWrap: 'balance' }}>
              <span className="italic">COCON</span> {t(tr.insideCocon.p1).replace('COCON ', '')}
            </p>
            <p 
              style={{ textWrap: 'balance' }}
              dangerouslySetInnerHTML={sanitizeHTML(t(tr.insideCocon.p2))}
            />
          </div>
          
          <div className="space-y-3 text-sm sm:text-base leading-[1.9] text-[#3F2A24]/80">
            <p style={{ textWrap: 'balance' }}>
              {t(tr.insideCocon.p3)}
            </p>
            <p style={{ textWrap: 'balance' }}>
              {t(tr.insideCocon.p4)}
            </p>
            <p style={{ textWrap: 'balance' }}>
              {t(tr.insideCocon.p5)}
            </p>
          </div>

          {/* Espacement aéré */}
          <div className="pt-10 pb-4">
            <Link
              to="/valouse/fragments"
              className="inline-flex items-center justify-center px-10 py-4 rounded-full bg-[#C5A059] text-[#3F2A24] text-xs tracking-[0.2em] uppercase font-medium shadow-md hover:bg-[#bdb7a7] hover:text-[#3F2A24] transition-colors duration-300"
              data-testid="cta-explorer-fragments"
            >
              Je choisis d'entrer
            </Link>
          </div>
          
        </div>
        
      </div>
    </section>
  );
};

export default InsideCoconSection;
